import {Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
    styleUrls: ['./simple-notification.component.less'],
    templateUrl: './simple-notification.component.html',
})
export class SimpleNotificationComponent {

    public msg: string;
    public btnText: string = 'Okay';

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    }

    ngOnInit() {
        this.msg = this.config.data.msg;
        this.btnText = this.config.data.btnText ?? this.btnText;
    }

    close() {
        this.ref.close();
    }

}
